import type { Money } from '~~/types/commercetools';

export default (money: Money): number => {

  const divider = Math.pow(10, money?.fractionDigits);

  return money ? money?.centAmount / divider : 0;

};
